import { lazy } from "react";
import i18n from "i18next";
import type { GameModule } from "../types";
import { KLONDIKE_NS, registerKlondikeTranslations } from "./i18n";

registerKlondikeTranslations(i18n);

/** Klondike (ADR 0078): a hidden-information game, played move by move by the server. */
export const klondikeModule: GameModule = {
  key: "klondike",
  namespace: KLONDIKE_NS,
  Player: lazy(() => import("./Player")),
};
